import script from "./ImgEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImgEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImgEditModal.vue?vue&type=style&index=0&id=cfca8034&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfca8034"]])

export default __exports__